import { ReactElement } from 'react';
import styles from './placeholder.component.module.scss';

interface HeightSinceWidthEntry {
  sinceWidth: number;
  height: number | string;
}

type HeightSinceWidth = HeightSinceWidthEntry[];

const getPlaceholderSelector = (cssId: string): string => `[id="${cssId}"].${styles.placeholder}`;

const formatHeight = (height: number | string): string => {
  return typeof height === 'number' ? `${height}px` : height;
};

const calculateStyleChunksMedia = (cssId: string, heightSinceWidth: HeightSinceWidth): string[] => {
  const sortedHeightSinceWith = [...heightSinceWidth].sort((entry1, entry2) => {
    return entry1.sinceWidth - entry2.sinceWidth;
  });
  return sortedHeightSinceWith.map((entry) => {
    const sinceWidth = entry.sinceWidth;
    const isMediaQuery = sinceWidth !== 0;

    let styleChunk = '';
    if (isMediaQuery) {
      styleChunk = `@media(min-width:${sinceWidth}px){`;
    }

    styleChunk = `${styleChunk}${getPlaceholderSelector(cssId)}{height:${formatHeight(
      entry.height
    )};}`;

    if (isMediaQuery) {
      styleChunk = `${styleChunk}}`;
    }

    return styleChunk;
  });
};

const calculateStyleChunksContainer = (
  cssId: string,
  heightSinceWidth: HeightSinceWidth
): string[] => {
  const sortedHeightSinceWith = [...heightSinceWidth].sort((entry1, entry2) => {
    return entry1.sinceWidth - entry2.sinceWidth;
  });
  return sortedHeightSinceWith.map((entry) => {
    const sinceWidth = entry.sinceWidth;
    const isContainerQuery = sinceWidth !== 0;

    let styleChunk = '';
    if (isContainerQuery) {
      styleChunk = `@container(min-width:${sinceWidth}px){`;
      styleChunk = `${styleChunk}${getPlaceholderSelector(cssId)}{height:${formatHeight(
        entry.height
      )};}`;
    }

    if (isContainerQuery) {
      styleChunk = `${styleChunk}}`;
    }

    return styleChunk;
  });
};

export const generateStyleTag = (
  cssId: string,
  heightSinceWidth: HeightSinceWidth
): ReactElement | null => {
  const styleChunksMedia = calculateStyleChunksMedia(cssId, heightSinceWidth);
  const styleChunksContainer = calculateStyleChunksContainer(cssId, heightSinceWidth);
  const styleChunksCombined = styleChunksMedia.concat(styleChunksContainer);

  return <style>{styleChunksCombined.join('')}</style>;
};
